export default __webpack_public_path__ + "static/Cloud-migration-deployment-c62da0d9354dd8904ea02f2d42a36a26.webp";